"use client";

import { useSession, signOut } from "next-auth/react";
import { useEffect } from "react";
import Cookies from "js-cookie";
import { useRouter } from "next/navigation";

export default function SessionMonitor() {
  const { data: session, update } = useSession();

  const router = useRouter();
  useEffect(() => {
    const checkToken = setInterval(() => {
      const token = Cookies.get("app_token");
      if (!token) {
        router.replace("/");
      }
    }, 1000); // Check every 1 second
    return () => clearInterval(checkToken);
  }, []);
  useEffect(() => {
    const checkSession = setInterval(() => {
      if (!session?.expires) return;

      const expiresTimestamp = new Date(session.expires).getTime();
      const currentTimestamp = Date.now();
      const timeRemaining = expiresTimestamp - currentTimestamp;

      // Session expired - trigger signout
      if (timeRemaining < 0) {
        signOut({
          callbackUrl: "/?error=SessionExpired",
          redirect: true,
        });
      }
    }, 30000); // Check every 30 seconds

    return () => clearInterval(checkSession);
  }, [session, update]);

  return null;
}
